import React, { useState } from "react"
import { Icon } from "@ncs/web-legos/components"
import { buttonStyle, mobileContactUsStyle } from "./style"

interface ContactUsProps {
	variant?: "normal" | "mobile"
}

const ContactUs: React.FC<ContactUsProps> = ({ variant = "normal" }) => {
	const [toggleContent, setToggleContent] = useState(false)
	const onToggleContent = () => setToggleContent(!toggleContent)
	const customIconColor = variant === "normal" ? "white" : "text"

	const ContactInfo = () => (
		<ul>
			<li>
				<a href="mailto:Parts@NCSwash.com">
					<span aria-hidden="true">
						<Icon icon="envelope" color={customIconColor} />
					</span>
					<span>Parts@NCSwash.com</span>
				</a>
			</li>
			<li>
				<a href="mailto:VC-CustomerService@NCSwash.com">
					<span aria-hidden="true">
						<Icon icon="envelope" color={customIconColor} />
					</span>
					<span>VC-CustomerService@NCSwash.com</span>
				</a>
			</li>
			<li>
				<a href="tel:+1-844-593-8549">
					<span aria-hidden="true">
						<Icon icon="phone" color={customIconColor} />
					</span>
					<span>1-844-593-8549</span>
				</a>
			</li>
		</ul>
	)
	const desktop = (
		<nav>
			<h2>Contact Us</h2>
			<ContactInfo />
		</nav>
	)

	const mobile = (
		<section css={mobileContactUsStyle}>
			<button onClick={onToggleContent} css={buttonStyle}>
				<span>Contact Us</span>
				{toggleContent ?
					<Icon icon="chevron-up" color="text" />
				:	<Icon icon="chevron-down" color="text" />}
			</button>
			{toggleContent && <ContactInfo />}
		</section>
	)

	return variant === "mobile" ? mobile : desktop
}

export default ContactUs
